<script lang="ts">
    import {getLocalization} from 'src/core';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {fly} from 'svelte/transition';

    export let topThreshold = 20;
    const flyAnimParams = {y: 10, duration: 250};
    const localize = getLocalization();

    let windowScrollY = 0;

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
</script>

<svelte:window bind:scrollY={windowScrollY}/>

{#if windowScrollY > topThreshold}
    <button class="kp-scroll-up-button"
            transition:fly={flyAnimParams}
            on:click={handleClick}
            title={localize(/* @kp-localization commons.MoveUp */ 'commons.MoveUp')}
            aria-label={localize(/* @kp-localization commons.MoveUp */ 'commons.MoveUp')}>

        <UIcon icon="arrow-small-up"/>
    </button>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "bootstrap-less/bootstrap/variables";

    @button-size: 50px;
    @icon-size: 20px;

    .kp-scroll-up-button {
        width: @button-size;
        height: @button-size;
        bottom: @spacing-l;
        right: @spacing-xl;
        position: fixed;
        z-index: 99;
        background-color: var(--header-bg-color);
        color: var(--header-text-color);
        font-size: @icon-size;
        cursor: pointer;
        opacity: 0.5;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        outline: none;
        border: none;
        transition: opacity 0.3s ease-in-out;

        @media (max-width: @screen-xs-max) {
            bottom: @spacing-m;
            right: @spacing-ml;
        }

        &:hover {
            opacity: 1;
        }
    }
</style>